/**
 * @file AssetHelpers.ts
 * @module _admin/helpers/AssetHelpers
 * @description Provides the AssetHelpers helper used for asset resolution, routing, sample data, and React compatibility support.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

export const toAbsoluteUrl = (pathname: string) =>
  process.env.PUBLIC_URL + pathname;
